/**
 * The orcaloops member surface's stylesheet as a render-blocking head link.
 *
 * A stylesheet the SSR markup depends on has to be a `<link>` in the head the
 * server sends (packages/web/CLAUDE.md → Performance budgets, rule 6); a
 * side-effect import from a lazy chunk paints raw and then jumps. So the sheet
 * arrives through a `?url` import here, and every route that mounts an
 * {@link OrcaloopsFrame} spreads these links into its `head()`. Mirrors
 * `loop-shell-head.ts`.
 *
 * @since 1.0.0
 */
import orcaloopsCss from "~/components/orcaloops/orcaloops.css?url";
import type { HeadLink } from "~/config/head.ts";

/**
 * The one sheet the orcaloops frame needs. Link it AFTER the app stylesheet
 * (which `src/config/head.ts` already places first) and before any page sheet.
 *
 * @since 1.0.0
 */
export const orcaloopsStylesheetLinks: Array<HeadLink> = [
  { rel: "stylesheet", href: orcaloopsCss },
];
